module.exports = __webpack_public_path__ + "public/img/promo-5.24ccd8b8.jpg";